import { app as App, auth as Auth, storage as Storage, db as Db } from '../Config/firebase';

export const app = App;
export const auth = Auth;
export const storage = Storage;
export const db = Db;
